import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { PresetGenericWidth, } from '../../../../../../shared/components/img-resize/image-resize.service';

@Component({
  selector: 'app-pro-listing-ad-faq',
  templateUrl: './pro-listing-ad-faq.component.html',
  styleUrls: ['./pro-listing-ad-faq.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProListingAdFaqComponent {

  @HostBinding('class.kz-pro-listing-ad-faq') class = true;

  public presetW460 = new PresetGenericWidth('w460');

  constructor() { }

}
